import { GameSettings } from "./types";
import { contentTypeIds } from "../types";

export const rogue: GameSettings = {
  enabledTabs: ["news", "blog"],
  enabledLocales: [
    "en",
    "fr",
    "de",
    "it",
    "ja",
    "ko",
    "pl",
    "pt",
    "ru",
    "es",
    "tr",
    "zh",
    "zh-hans",
  ],
  enabledNotificationTypes: ["standard"],
  availableButtonVariants: ["orange", "cyan", "purple", "pink"],
  referenceWidth: 850,

  availableCategories: [
    {
      id: "news",
      name: {
        de: "News",
        en: "News",
        es: "Novedades",
        fr: "Actus",
        it: "Notizie",
        ja: "ニュース",
        ko: "뉴스",
        pl: "Aktualności",
        pt: "Notícias",
        ru: "Новости",
        tr: "Haberler",
        zh: "新聞",
        "zh-hans": "新闻",
      },
      color: "#000AFF",
      secondaryColor: "#74FAE3",
    },
    {
      id: "community",
      name: {
        de: "Community",
        en: "Community",
        es: "Comunidad",
        fr: "Communauté",
        it: "Community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        pl: "Społeczność",
        pt: "Comunidade",
        ru: "Сообщество",
        tr: "Topluluk",
        zh: "社群",
        "zh-hans": "社区",
      },
      color: "#7F00D9",
    },
    {
      id: "game-updates",
      name: {
        de: "Spielupdates",
        en: "Game Updates",
        es: "Actualizaciones",
        fr: "Mises à jour",
        it: "Aggiornamenti del gioco",
        ja: "ゲームアップデート",
        ko: "게임 업데이트",
        pl: "Aktualizacje gry",
        pt: "Novidades do jogo",
        ru: "Обновления игры",
        tr: "Oyun Güncellemeleri",
        zh: "遊戲更新",
        "zh-hans": "游戏更新",
      },
      color: "#8757FF",
    },
    {
      id: "release-notes",
      name: {
        de: "Versionshinweise",
        en: "Release Notes",
        es: "Notas de actualización",
        fr: "Notes de patch",
        it: "Note di rilascio",
        ja: "リリース情報",
        ko: "릴리스 노트",
        pl: "Informacje o wersji",
        pt: "Notas de lançamento",
        ru: "Информация о версии",
        tr: "Sürüm Notları",
        zh: "更新說明",
        "zh-hans": "更新详情",
      },
      color: "#019258",
    },
    {
      id: "fun",
      name: {
        de: "Spaß",
        en: "Fun",
        es: "Diversión",
        fr: "Fun",
        it: "Divertimento",
        ja: "エンタメ",
        ko: "엔터테인먼트",
        pl: "Rozrywka",
        pt: "Diversão",
        ru: "Развлечения",
        tr: "Eğlence",
        zh: "趣聞",
        "zh-hans": "趣闻",
      },
      color: "#2B2A01",
      secondaryColor: "#FFE52C",
    },
    {
      id: "Art",
      name: {
        de: "Artwork",
        en: "Art",
        es: "Arte",
        fr: "Art",
        it: "Galleria",
        ja: "アート",
        ko: "아트",
        pl: "Grafiki",
        pt: "Arte",
        ru: "Арт",
        tr: "Sanat Öğeleri",
        zh: "藝術創作",
        "zh-hans": "艺术创作",
      },
      color: "#2B2A01",
      secondaryColor: "#FFE52C",
    },
    {
      id: "fanart",
      name: {
        de: "Fanart",
        en: "Fanart",
        es: "Creaciones de fans",
        fr: "Fanart",
        it: "Creazioni dei fan",
        ja: "ファンアート",
        ko: "팬아트",
        pl: "Fanarty",
        pt: "Criações dos fãs",
        ru: "Фан-арт",
        tr: "Hayranlardan İçerikler",
        zh: "玩家作品",
        "zh-hans": "同人作品",
      },
      color: "#2B2A01",
      secondaryColor: "#FFE52C",
    },
    {
      id: "esports",
      name: {
        de: "E-Sports",
        en: "Esports",
        es: "eSports",
        fr: "E-sport",
        it: "Esports",
        ja: "eスポーツ",
        ko: "e스포츠",
        pl: "E-sport",
        pt: "E-sports",
        ru: "Киберспорт",
        tr: "E-spor",
        zh: "電競賽事",
        "zh-hans": "电竞",
      },
      color: "#FF5F2C",
    },
    {
      id: "video",
      name: {
        de: "Video",
        en: "Video",
        es: "Vídeos",
        fr: "Vidéo",
        it: "Video",
        ja: "動画",
        ko: "영상",
        pl: "Wideo",
        pt: "Vídeos",
        ru: "Видео",
        tr: "Video",
        zh: "影片",
        "zh-hans": "视频",
      },
      color: "#665E91",
    },
  ],

  enabledComposePages: ["news", "events"],

  resolutions: {
    [contentTypeIds.smallNewsEntryExternalLink]: {
      linkThumbnail: {
        width: 880,
        height: 880,
      },
    },

    [contentTypeIds.smallNewsEntryArticle]: {
      smallThumbnail: {
        width: 880,
        height: 880,
      },
      heroImage: {
        width: 1600,
        height: 443,
      },
      websiteHeroImage: null,
    },

    [contentTypeIds.newsEntryArticle]: {
      heroImage: {
        width: 1600,
        height: 443,
      },
      largeThumbnail: {
        width: 800,
        height: 433,
      },

      websiteHeroImage: null,
    },
    [contentTypeIds.newsEntryExternalLink]: {
      linkThumbnail: {
        width: 800,
        height: 433,
      },
    },
    [contentTypeIds.videoBlock]: {
      videoThumbnail: {
        width: 960,
        height: 540,
      },
    },
    [contentTypeIds.newsEntryVideo]: {
      videoThumbnail: {
        width: 800,
        height: 433,
      },
    },
    [contentTypeIds.imageBlock]: {
      image: null,
    },
    [contentTypeIds.featureBlock]: {
      featureThumbnail: {
        width: 300,
        height: 300,
      },
    },
    [contentTypeIds.pollBlock]: {
      option1Image: {
        width: 240,
        height: 380,
      },
      option2Image: {
        width: 240,
        height: 380,
      },
      option3Image: {
        width: 240,
        height: 380,
      },
      option4Image: {
        width: 240,
        height: 380,
      },
      option5Image: {
        width: 240,
        height: 380,
      },
    },
    [contentTypeIds.carouselEventEntry]: {
      carouselImage: {
        width: 800,
        height: 1161,
      },
    },
    [contentTypeIds.carouselEventPollEntry]: {
      carouselImage: {
        width: 800,
        height: 1161,
      },
      option1Image: {
        width: 240,
        height: 380,
      },
      option2Image: {
        width: 240,
        height: 380,
      },
      option3Image: {
        width: 240,
        height: 380,
      },
      option4Image: {
        width: 240,
        height: 380,
      },
      option5Image: {
        width: 240,
        height: 380,
      },
    },
    [contentTypeIds.carouselEventProgressTrackerEntry]: {
      carouselImage: {
        width: 1280,
        height: 720,
      },
    },
    [contentTypeIds.newsEntryImage]: {
      imageNewsThumbnail: {
        width: 800,
        height: 433,
      },
    },

    [contentTypeIds.localizedHero]: {
      image: {
        width: 960,
        height: 360,
      },
    },

    [contentTypeIds.localizedSpotlight]: {
      image: {
        width: 1280,
        height: 720,
      },
    },

    [contentTypeIds.eventCalendarEntry]: {
      backgroundImage: {
        width: 1920,
        height: 720,
      },
    },

    [contentTypeIds.calendarEventEntry]: {
      image: {
        width: 512,
        height: 512,
        fit: "default",
      },
    },

    [contentTypeIds.calendarEventReward]: {
      image: {
        width: 256,
        height: 256,
      },
    },
  },

  supportPolls: true,
  supportTargetPolls: false,
  supportSmallArticles: true,
  targetingFields: ["country", "countryExclude", "platform"],
  preRegBlogSyncEnabled: true,
  gridEnabled: true,
  supportProgressTrackerEntry: true,
};
